/**
 * Created by fers on 05.02.16.
 */

import {injectIntl, FormattedMessage, IntlShape} from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {sendError} from '../app/errorDisplayer';
import "./Scenario.scss";
import {safeJSONparse} from "../../common/util/safeJSONparse";
import { Organisation, Scenario } from '../../common/types/types';

interface ScenarioBoxAsWizardProps {
    activeChannel?: object;
    activeChannelDef?: object;
    intl?: object;
    organisation?: Organisation;
    scenario: Scenario;
}

class ScenarioBoxAsWizard extends React.Component<ScenarioBoxAsWizardProps> {

    static propTypes = {
        activeChannel: PropTypes.object,
		activeChannelDef: PropTypes.object,
		intl: PropTypes.object,
        organisation: PropTypes.object,
        scenario: PropTypes.object.isRequired,
    };

	isActivated(item) {
        let channelDef = item.channelDef;
        if (!this.props.organisation) {
            return false;
        }

		if (!this.props.organisation.channels || !this.props.organisation.channels.edges) {
			sendError(new Error("Missing channels object"), JSON.stringify(this.props.organisation));
			return false;
		}

        let channels = this.props.organisation.channels.edges;

        let metadata = safeJSONparse(channelDef.metadata);

        if (!metadata.canUserAdd) {
            return true;
        }

        for (let node of channels) {
            let channel = node.node;

            if (channel['channelDef'] && channel['channelDef']['realId'] === channelDef['realId']) {
                if (!channel.activated) {
                    return false;
                }

                return true;
            }
        }

        return false;
	}

	isActivating(item) {
		let activeChannelDef = this.props.activeChannelDef;
		if (activeChannelDef) {
            return activeChannelDef.id === item.channelDef.id;
        }

        if (this.props.activeChannel) {
            return this.props.activeChannel.channelDef.id === item.channelDef.id;
        }

        return false;
    }

    render() {
        const { scenario } = this.props;

        let scenarios2ChannelDefs = scenario.scenarios2ChannelDefs.edges.map(({node}) => node);

        let activatedLists = scenarios2ChannelDefs.filter((item) => this.isActivated(item) && !this.isActivating(item));
		let activatingList = scenarios2ChannelDefs.filter((item) => this.isActivating(item));
        let notActivatedLists = scenarios2ChannelDefs.filter((item) => !this.isActivated(item) && !this.isActivating(item));

        return (
            <div className="scenarioGridList-wizardBox">
                <div className="finished">
					<h4><FormattedMessage defaultMessage="Activated:" id="scenarioBoxWizard.activatedList" /></h4>
					<div className="scenarioGridList-checklist">
						{activatedLists.map((item, idx) => {
							return (<div className="done" key={idx}>
								<div className="scenarioGridList-text">{item.channelDef.name}</div>
							</div>);
						})}
						{activatedLists.length === 0 ? <span className="empty"><FormattedMessage defaultMessage="Nothing yet" id="scenarioBoxWizard.nothingYet" /></span> : null}
					</div>
				</div>

				{activatingList.length > 0 ? <div className="activating">
					<h4><FormattedMessage defaultMessage="Activating:" id="scenarioBoxWizard.activating" /></h4>
                    <div className="scenarioGridList-checklist">
                        {activatingList.map((item, idx) => {
                            return (<div className="active" key={idx}>
                                <div className="scenarioGridList-text">{item.channelDef.name}</div>
                            </div>);
                        })}
                    </div>
                </div> : null}

                <div className="todo">
					<h4><FormattedMessage defaultMessage="To activate:" id="scenarioBoxWizard.toActivate" /></h4>
                    <div className="scenarioGridList-checklist">
                        {notActivatedLists.map((item, idx) => {
                            return (<div key={idx}>
                                <div className="scenarioGridList-text">{item.channelDef.name}</div>
                            </div>);
                        })}
						{notActivatedLists.length === 0 ? <span className="empty"><FormattedMessage defaultMessage="Everything done" id="scenarioBoxWizard.everythingDone" /></span> : null }
                    </div>
                </div>
            </div>
        );
    }
}
export default Relay.createContainer(injectIntl(ScenarioBoxAsWizard), {
    fragments: {
        scenario: () => Relay.QL`
            fragment on Scenario {
                id,
                name,
                title,
                description,
                state,
                visibility,
                scenarioDef {
                    id,
                    name,
                    realId,
                },
                scenarios2ChannelDefs(first: 100) {
                    edges {
                        node {
                            id,
                            realId,
                            ruleType,
                            channelDef {
                                id,
                                realId,
                                metadata,
                                name,
                                icon
                            }
                        }
                    }
                }
            }
        `,
        organisation: () => Relay.QL`
            fragment on Organisation {
                id,
                channels(first: 100, deleted: false) {
                    edges {
                        node {
                            id,
                            realId,
                            deleted,
                            activated,
                            channelDef {
                                id,
                                realId,
                                name,
                                icon
                            }
                        }
                    }
                },
                unactivatedChannels: channels(first: 100, activated: false) {
                    edges {
                        node {
                            id,
                            realId,
                            activated,
                            channelDef {
                                id,
                                realId,
                                name,
                                icon
                            }
                        }
                    }
                },
            }
        `,
    },
});
